import logo from "./logo.svg";
import "./App.css";
import Home from "./comp/home/Home";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Home></Home>
        <h1> This is Mithu ChowDhuRy</h1>
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
